import styles from '../shop.module.css';

export default function TopBar() {
  return (
    <div className={styles.topBar}>
      <h2 className={styles.pageTitle}>Shop All Products</h2>
      
      <div className={styles.sortFilter}>
        <select className={styles.sortSelect}>
          <option>Featured</option>
          <option>Price: Low to High</option>
          <option>Price: High to Low</option>
          <option>Newest</option>
        </select>
      </div>
    </div>
  );
}
